module.exports = __webpack_public_path__ + "static/media/5lg.c4f2a3fb.jpg";